﻿(function (angular, ToyotaForms) {
    'use strict';

    angular.module('Toyota.Factories')
        .factory('Dealers', ['$q', '$filter', 'API', function ($q, $filter, API) {
            return function (postcode, suburb, maxresults, servicetype) {
                var url = $filter('formatArgs')(ToyotaForms.API.Info.Dealers, [postcode, suburb, maxresults, servicetype]);

                var deferred = $q.defer();

                API.get(url).then(function (req) {
                    deferred.resolve(req.data.results);
                }, function () {
                    deferred.resolve([]);
                });

                return deferred.promise;
            };
        }]);
})(window.angular, window.ToyotaForms);
